import { createContext } from 'react';

import { OrganizationNetSuiteCustomers } from '@totem/components/orgManagement/orgDetails/netSuiteKeys/types';

interface Context {
  customers: OrganizationNetSuiteCustomers;
  onRefresh: () => void;
}

export default createContext<Context>({
  customers: [],
  onRefresh: () => {},
});
